import React from 'react';
import HeaderSmall from '../Components/Header/HeaderUnauthorized';
import Content from '../Components/Content';
import Paper from 'material-ui/Paper';

class TermsOfUsePage extends React.Component {
    render() {
        return (
            <div>
                <HeaderSmall  useBackFunction={true}>
                    <span className="white" >Terms of Use</span>
                </HeaderSmall>
                <div className="container" >
                    <Paper>
                        <Content contentKey="termsofuse" />
                    </Paper>
                </div>
            </div>
        );
    }
};

export default TermsOfUsePage;


// WEBPACK FOOTER //
// ./src/Pages/TermsOfUse.js